/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessPartyExtended } from '../../models/business-party-extended';

export interface ByBpGuidExtended$Params {
  bpGuid: string;
}

export function byBpGuidExtended(http: HttpClient, rootUrl: string, params: ByBpGuidExtended$Params, context?: HttpContext): Observable<StrictHttpResponse<BusinessPartyExtended>> {
  const rb = new RequestBuilder(rootUrl, byBpGuidExtended.PATH, 'get');
  if (params) {
    rb.path('bpGuid', params.bpGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BusinessPartyExtended>;
    })
  );
}

byBpGuidExtended.PATH = '/business-parties/{bpGuid}/extended';
